import { useMemo } from 'react';

import { Button, DataTable, Icon, Modal, Tag, Text } from '@nvision/ui';

import { useTariffPricing } from '../../../hooks';

import styles from './pricing-card.module.css';

const columns = [
  {
    accessorKey: 'pricingKey',
    header: 'Pricing Key',
    size: 90,
  },
  {
    accessorKey: 'cargoType',
    header: 'Cargo Type',
    size: 100,
  },
  {
    accessorKey: 'customer',
    header: 'Customer',
    size: 100,
  },
  {
    accessorKey: 'transportationProvider',
    header: 'Transportation Provider',
    size: 140,
  },
];

interface PricingCardProps {
  isOpen: boolean;
  setIsOpen: React.Dispatch<React.SetStateAction<boolean>>;
  tariffKey: number;
}

export const PricingCard: React.FC<PricingCardProps> = ({ isOpen = false, setIsOpen, tariffKey }) => {
  const { data: pricing, isLoading } = useTariffPricing(tariffKey, { enabled: isOpen });

  const rows = useMemo(
    () =>
      (pricing ?? []).map((item) => ({
        cargoType: item.cargoType?.label ?? '—',
        customer: item.customer.name,
        id: String(item.pricingKey),
        pricingKey: item.pricingKey,
        transportationProvider: item.carrier.carrierName,
      })),
    [pricing],
  );

  return (
    <Modal
      isOpen={isOpen}
      onOpenChange={(value) => {
        setIsOpen(value);
      }}
      className={styles.modal}
    >
      <Modal.Header className={styles.header}>
        <div className={styles.title}>
          <Text size="xlg" weight="semibold">
            Pricing List
          </Text>

          <Tag success>
            <Text size="sm">{tariffKey}</Text>
          </Tag>
        </div>
        <Icon name="x" onClick={() => setIsOpen(false)} cursor="pointer" />
      </Modal.Header>
      <Modal.Content>
        <DataTable
          isLoading={isLoading}
          data={rows}
          columns={columns}
          page={1}
          translations={{ noData: 'No pricing found' }}
        />
      </Modal.Content>
      <Modal.Footer className={styles.footer}>
        <Button outline secondary onClick={() => setIsOpen(false)}>
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  );
};
